module.exports = __webpack_public_path__ + "assets/aa2a658ee153dcaae4f080697d743140.png";